import React from "react";
import PropTypes from "prop-types";
import _ from "lodash"
import { withStyles, Grid,Button,Divider,Card } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import InfoIcon from '@material-ui/icons/Info';
import { withFirestore,firestoreConnect,isLoaded, isEmpty  } from 'react-redux-firebase'
import { connect } from 'react-redux'
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner"
import {
    NewSurveyTile,
    SurveyTile
} from "../../components";

import {compose} from "redux"


class Surveys extends React.Component {


    state={
        selectedOrganisation: ""
    }


    createNewSurvey=()=>{
        const {history,firestore,user} = this.props

        var isDemo = user&&user.role==="SuperAdmin"?true:false;

        if(user.selectedOrganisation){
            
            firestore.add('surveys',{
                isDemo:isDemo,
                isActive: false,
                allowSurveyCompletionTimes:10,
                organisationID: user.selectedOrganisation,
                versionId:firestore.FieldValue.serverTimestamp() ,
                createdAt: firestore.FieldValue.serverTimestamp()
            }).then((result)=>{
                history.push(`/survey/${result.id}/edit`)
            })
        }

    }

    viewSurvey=(surveyId)=>{
        const {history} = this.props
        history.push(`/survey/${surveyId}/view`)
    }


    componentWillMount(){
        const {user} = this.props
        this.setState({selectedOrganisation: user?user.selectedOrganisation:""})
    }
    render() {

        const {classes,surveys,user} = this.props

        let userOrganisationSurveys = []

        console.log( this.props)

        if(user && surveys){
            userOrganisationSurveys = Object.entries(surveys).filter((survey) => {
                if(survey[1]){
                    return user.selectedOrganisation && survey[1].organisationID == user.selectedOrganisation &&
                    ((user.role === "SuperAdmin" && survey[1].isDemo === true ) || user.role !== "SuperAdmin" && survey[1].isDemo === false )
                }
            })
        }

        return(userOrganisationSurveys.length>0?
                <div className={classes.root}>
                    <div>
                        <div className={classes.sectionHeader}>
                            <h3 style={{marginTop:40,marginLeft:20,color:"rgb(85, 85, 85)",fontSize: 20,fontWeight:600}}>Start a new campaign</h3> 
                        </div>
                        <div  style={{height: 180}} >
                                <Grid item>
                                        <NewSurveyTile onClick={this.createNewSurvey}/>
                                </Grid>
                        </div>
                    </div>                  
                    <div style={{marginLeft:20}} className={classes.sectionHeader}>
                        <h3 style={{color:"rgb(85, 85, 85)",fontSize: 15,fontWeight:600}}>Recent campaigns</h3> 
                        <Divider/>            
                    </div>
                    <Grid container className={classes.sectionContent}>
                        {_.map(userOrganisationSurveys,(survey,key)=>{
                            return(
                                <Grid key={survey[0]} item>
                                    <SurveyTile createdAt={survey[1].createdAt} status={survey[1].isActive} onClick={()=>{this.viewSurvey(survey[0])}} title={survey[1].name} subText={survey[1].description}/>
                                </Grid>
                            )
                        })
                        }
                    </Grid>

                </div>
                :
                !surveys&&!isLoaded(surveys)?
                   <div style={styles.loaderStyle}>
                      <LoadingSpinner size={50} thickness={3}></LoadingSpinner>
                   </div>
                   :
                   user&&user.selectedOrganisation&&user.selectedOrganisation!==undefined&&user.selectedOrganisation!==""?
                   <div>
                    <div className={classes.sectionHeader}>
                    <h3 style={{marginTop:40,marginLeft:20,color:"rgb(85, 85, 85)",fontSize: 20,fontWeight:600}}>Start a new campaign</h3> 
                        </div>
                        <div  style={{height: 180}} >
                                <Grid item>
                                        <NewSurveyTile onClick={this.createNewSurvey}/>
                                </Grid>
                        </div>
                    </div>
                   :
                   <div style={{width:"70%",alignItems:"center",justifyContent:"center",marginTop:"20%",marginLeft:"15%"}} >
                        <Card style={{width:"100%",alignItems:"center",justifyContent:"center"}}>
                            <h6 style={{textAlign:"center",color:"#FF9900"}}><InfoIcon style={{marginBottom:-20,marginRight:10,fontSize:57}}/>You are not part of any organisation</h6>
                            <p style={{textAlign:"center",marginBottom:40,color:"rgb(168, 168, 168)"}}>
                            To view campaigns you must be part of an organisation.</p>
                        </Card>    
                   </div>                     
        )
    }

}

const styles={
    root:{
        display:"flex",
        flexGrow:1,
        flex:1,
        flexDirection:"column"
    },
    statsContent:{
        flex:1,
        height:400,
    },

    sectionHeader:{

    },
    sectionContent:{
        display:"flex",
        flexDirection:"row",
        justifyContent:"flex-start",
    },
    createSurveyButton:{
        position: 'absolute',
        bottom: 100,
        right: 100,
    },

    loaderStyle:{
        justifyContent:"center",
        alignItems:"center",
        marginTop:"20%",
        marginLeft:"50%"
    }
}

export default compose(
    withFirestore,
    withStyles(styles),
    connect((state)=>{
        return {
            user: state.firebase.profile,
            surveys: state.firestore.data.surveys
        }
    }),
    firestoreConnect((props) =>{
    
        if(isLoaded(props.user)){
            return[{collection:"surveys",
             //   where: ['organisationID', '==', props.user.selectedOrganisation]
            }
            ]
        }
        else{
            return []
        }

    }

    )
)(Surveys)


// WEBPACK FOOTER //
// ./src/views/Surveys/Surveys.jsx